import { Component } from '@angular/core'

@Component({
    selector: 'app-instagram-link-icon',
    templateUrl: './instagram-link-icon.component.html',
    styleUrls: ['./instagram-link-icon.component.css'],
    standalone: true,
})
export class InstagramLinkIconComponent {}
